import { TriangleAlert } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface ErrorStateProps {
  title?: string;
  message?: string;
  onRetry?: () => void;
  className?: string;
}

/**
 * Displays a recoverable error state with an optional retry action.
 *
 * @param props Error state props.
 * @return Error state markup.
 */
export function ErrorState({ title = "Couldn't load data", message, onRetry, className }: ErrorStateProps) {
  return (
    <div className={cn("border border-red-200 rounded-lg bg-white px-8 py-16 text-center", className)}>
      <div className="mx-auto w-10 h-10 rounded-lg bg-red-50 flex items-center justify-center mb-4">
        <TriangleAlert className="w-5 h-5 text-red-500" />
      </div>
      <h3 className="text-sm font-semibold text-brand-950 mb-1">{title}</h3>
      <p className="text-sm text-slate-500 max-w-[320px] mx-auto">
        {message || "Something went wrong while loading. Check your connection and try again."}
      </p>
      {onRetry && (
        <div className="mt-5">
          <Button variant="secondary" size="sm" onClick={onRetry}>
            Try again
          </Button>
        </div>
      )}
    </div>
  );
}
